import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { LogModuleRoutes } from '@app/modules/log/log-routes';
import { LogAuthGuard } from '@app/core/guards/log-auth.guard';
import { ClientActivityLogComponent } from '@app/modules/log/pages/client-activity-log/client-activity-log.component';
import { CaseActivityLogComponent } from '@app/modules/log/pages/case-activity-log/case-activity-log.component';
import { BillingLogComponent } from '@app/modules/log/pages/billing-log/billing-log.component';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export const routes: Routes = [
    { path: LogModuleRoutes.CLIENT_ACTIVITY_LOG, component: ClientActivityLogComponent, canActivate: [LogAuthGuard], data: { breadcrumb: marker('log.client_activity_log.breadcrumb') } },
    { path: LogModuleRoutes.CASE_ACTIVITY_LOG, component: CaseActivityLogComponent, canActivate: [LogAuthGuard], data: { breadcrumb: marker('log.case_activity_log.breadcrumb') } },
    { path: LogModuleRoutes.BILLING_LOG, component: BillingLogComponent, canActivate: [LogAuthGuard], data: { breadcrumb: marker('log.billing_log.breadcrumb') } },
];

export const routing = RouterModule.forChild(routes);

@NgModule({
    imports: [routing],
    exports: [RouterModule]
})
export class LogRoutingModule {}
